import { apiClient } from "./api";

// Types for usage records and the overall response
export interface AgentUsageRecord {
  record_id: string;
  agent_id: string;
  product_sku: string;
  product_name?: string; // Enriched field
  product_description?: string; // Enriched field
  credits_used: number;
  timestamp: string; // or Date, if needed
  // ...any other fields returned by your usage system...
  metadata?: Record<string, any>;
}

export interface AgentUsageResponse {
  agent_id: string;
  time_period: {
    start: string | null;
    end: string | null;
  };
  records: AgentUsageRecord[];
}

/**
 * Get all usage (API calls) for a particular agent, optionally filtered
 * by a start and end time. The endpoint itself should enrich the usage
 * with product_name, product_description, etc.
 */
export const getAgentUsage = async (
  agentId: string,
  startTime?: string,
  endTime?: string,
): Promise<AgentUsageResponse> => {
  try {
    // Build query params if startTime / endTime are provided
    const params: Record<string, string> = {};
    if (startTime) params.start_time = startTime;
    if (endTime) params.end_time = endTime;

    const response = await apiClient.get(`/api/agent-usage/${agentId}`, {
      params, // axios will serialize the query params
    });

    return response.data; // Should match the AgentUsageResponse shape
  } catch (error) {
    console.error(`Error fetching usage for agent ${agentId}:`, error);
    throw error;
  }
};
